const ProgramAccommodationTypeEnum = {
  NIGHT_TRANSFER: 'nightTransfer',
  FREE_ACCOMMODATION : 'freeAccomodation',
  NO_ACCOMMODATION : 'noAccomodation'
}

export default ProgramAccommodationTypeEnum;